(function() {
  if (window.SandSeaContinuousScrollInstalled) return;
  window.SandSeaContinuousScrollInstalled = true;

  var observer;
  var activeRequest = null;
  var mutationTimer;

  function productGrid(scope) {
    return (scope || document).querySelector('.collection-grid__wrapper > .grid.grid--uniform');
  }

  function observeSentinel() {
    var sentinel = document.querySelector('[data-continuous-scroll]');
    if (!sentinel || sentinel.dataset.continuousScrollReady === 'true') return;

    if (!sentinel.dataset.nextUrl) {
      sentinel.remove();
      return;
    }

    sentinel.dataset.continuousScrollReady = 'true';

    if (observer) observer.disconnect();
    observer = new IntersectionObserver(function(entries) {
      if (entries[0] && entries[0].isIntersecting) loadNextPage(sentinel);
    }, { rootMargin: '700px 0px' });

    observer.observe(sentinel);
  }

  async function loadNextPage(sentinel) {
    if (!sentinel || sentinel.classList.contains('is-loading')) return;

    var nextUrl = sentinel.dataset.nextUrl;
    var currentGrid = productGrid(document);
    if (!nextUrl || !currentGrid) return;

    sentinel.classList.add('is-loading');

    try {
      activeRequest = new AbortController();
      var response = await fetch(nextUrl, {
        credentials: 'same-origin',
        signal: activeRequest.signal,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!response.ok) throw new Error('Could not load the next collection page');

      var html = await response.text();
      var nextDocument = new DOMParser().parseFromString(html, 'text/html');
      var nextGrid = productGrid(nextDocument);
      var nextSentinel = nextDocument.querySelector('[data-continuous-scroll]');

      if (!document.contains(sentinel) || currentGrid !== productGrid(document)) return;
      if (!nextGrid) throw new Error('Product grid was not found');

      Array.from(nextGrid.children).forEach(function(product) {
        var importedProduct = document.importNode(product, true);
        var animatedElements = Array.from(importedProduct.querySelectorAll('[data-aos]'));
        if (importedProduct.matches && importedProduct.matches('[data-aos]')) {
          animatedElements.unshift(importedProduct);
        }
        animatedElements.forEach(function(element) {
          element.classList.add('aos-init', 'aos-animate');
        });
        currentGrid.appendChild(importedProduct);
      });

      document.dispatchEvent(new CustomEvent('collection:continuous-scroll:loaded'));

      if (nextSentinel && nextSentinel.dataset.nextUrl) {
        sentinel.dataset.nextUrl = nextSentinel.dataset.nextUrl;
        sentinel.classList.remove('is-loading');
        sentinel.dataset.continuousScrollReady = 'false';
        observeSentinel();
      } else {
        sentinel.remove();
        if (observer) observer.disconnect();
      }
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('[Continuous scroll]', error);
        sentinel.classList.remove('is-loading');
        var fallback = sentinel.querySelector('.continuous-scroll__fallback');
        if (fallback) {
          fallback.style.position = 'static';
          fallback.style.width = 'auto';
          fallback.style.height = 'auto';
          fallback.style.margin = '0';
          fallback.style.overflow = 'visible';
          fallback.style.clip = 'auto';
        }
      }
    } finally {
      activeRequest = null;
    }
  }

  var mutationObserver = new MutationObserver(function() {
    clearTimeout(mutationTimer);
    mutationTimer = setTimeout(function() {
      if (activeRequest && !document.querySelector('[data-continuous-scroll].is-loading')) {
        activeRequest.abort();
      }
      observeSentinel();
    }, 80);
  });

  function start() {
    observeSentinel();
    mutationObserver.observe(document.getElementById('CollectionAjaxContent') || document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();